<template>
    <div class="service-content">
        <div class="title">
            <div class="title-text">精品源码</div>
            <router-link class="check-more" target="_blank" to="/sourceCode">查看更多</router-link>
        </div>
        <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
        <div v-else>
            <div class="service-content-list">
                <div class="service-content__item" v-for="(item, index) in list" :key="index">
                    <ServiceCard :sourceCode="item" @set-source-code="setSourceCode" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSourceCodeHot } from '@/api/sourceCode';
import ServiceCard from '../../SourceCode/components/SourceCodeCard';
import EmptyPage from '@/components/EmptyPage'; 
import { openWindow } from '@/utils/utils';

export default {
    name: 'CardList',
    components: {
        ServiceCard,
        EmptyPage
    },
    inject:['backTop'],
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        loading: true,
        total: 0,
        pageSize: 10,
        pageNum: 1,
        list: [],
    }),
    computed: {
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                };
                const res = await getSourceCodeHot(params);

                const { code, data } = res;
                if (res && code === 0) {
                    this.list = data.result || []
                    this.total = data.total;
                    this.list.forEach(item => {
                        item.formatList = item.categoryList&& item.categoryList.length ? (item.categoryList[0].techChildList || []).map(subItme => ({name:(subItme.categoryName||'').toLowerCase()})) : []
                    })
                }
            } catch (e) {
                throw e;
            } finally {
                this.loading = false;
            }
        },
        setSourceCode(sourceCode) {
			if (!sourceCode.id) {
				return;
			}
			openWindow(`/#/sourceCode/detail/${sourceCode.id}`)
		}
    }
};
</script>

<style lang="scss" scoped>
.service-content {
    width: 1600px;
    margin: 50px 0 40px 0;
    &__item {
        display: inline-block;
        width: 300px;
        margin-right: 25px;
        margin-bottom: 25px;

        &:nth-child(5n + 5) {
            margin-right: 0;
        }
    }
    .title {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .check-more {
            color: #9DA1B5;
            cursor: pointer;
            font-weight: 400;
            font-size: 18px;
        }
        .title-text {
            color: #333333;
            font-size: 26px;
            font-weight: 600;
        }
    }
}

// 小屏
@include mq($small) {
    .service-content {
        width: 1200px;
        &__item {
            width: 228px;
            margin-right: 15px;
            margin-bottom: 15px;
        }
    }
}
// 小屏
@include mq($smaller) {
    .service-content {
        width: unset;
        &__item {
            width: 219px;
            margin-right: 15px;
            margin-bottom: 15px;
            &:nth-child(4n + 4) {
                margin-right: 0;
            }
            &:nth-child(5n + 5) {
                margin-right: 15px;
            }
        }
    }
}
</style>